import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper.js';
import { onePageReprintPendency } from '../../../../services/modules/printlabelservices.js';

export default {
    name: 'newallocationpage',
    components: {
        VueElementLoading,
    },
    props: [],
    mixins: [PageTracker],
    data() {
        return {
            isLoading: false,
            ActiveTabIndex: 0,
            isloading: false,
            reprintPendencyList: [],
            userrole: '',
            totalPrintreprintPendencyList: 0,
            hubId:'',
            localuserid:'',
            username:'',
        }
    },
    computed: {

    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);

        this.username = userdetail.username;
        this.localuserid = userdetail.userid
        this.hubId = userdetail.hubdetails[0];
        this.userrole = userdetail.userrole[0].rolename;
        this.getReprintPendencyList()
    },
    methods: {
        getReprintPendencyList() {
            this.reprintPendencyList = [];
            let reqPayload = {
                "hubid": this.hubId,
                "approvalrole": [this.userrole.toLowerCase()],
            }
            onePageReprintPendency(reqPayload, (result) => {
                console.log("----"+JSON.stringify(result.data.data));
                
                try {
                    if (result.data.code == 200) {
                        this.reprintPendencyList = result.data.data
                        this.totalPrintreprintPendencyList = result.data.data;
                    }
                } catch (error) {
                    console.log("-------Error----------", error);
                }
            })
        },
        exportToCSV() {
            const rows = [
              ["Flyer Id", "Last Printed By","Pending Since"],
              ...this.reprintPendencyList.map(row => [row.flyerbarcode, row.requestedby,row.requesteddate])
            ];
      
            let csvContent = "data:text/csv;charset=utf-8,"
              + rows.map(e => e.join(",")).join("\n");
      
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "reprintpendency.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/RVPPrintPendency/RVPPrintPendency.component.js